import React from 'react'

export const SourceTag = ({ source }) => <div>{source || 'Uploaded'}</div>
